import React from 'react';
import PropTypes from 'prop-types';

import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import ProductCardImageComingSoon from './ProductCardImageComingSoon';

const ProductCardStudioImage = ({
  cropData,
  disableImageLazyLoading,
  image,
  isMobile,
}) => {
  if (!image) {
    return <ProductCardImageComingSoon />;
  }

  const imageWidthAndHeight = isMobile ? 265 : 341;

  return (
    <JBProductImage
      ar="1:1"
      className="w-full h-full"
      crop={!cropData ? 'center' : undefined}
      cropFormat="1x1"
      crops={cropData}
      enableCrops
      height={imageWidthAndHeight}
      lazy={!disableImageLazyLoading}
      src={image}
      width={imageWidthAndHeight}
    />
  );
};

ProductCardStudioImage.propTypes = {
  cropData: PropTypes.object,
  disableImageLazyLoading: PropTypes.bool,
  image: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ProductCardStudioImage;
